import React, { useState, useEffect } from 'react'
import { InputText } from '../../../ui'
import { MAX_LENGTH, LATIN_WITH_NUMBERS_SYMBOLS } from '../../../constants/constants'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../StateProvider'
import { getUserValue } from '../utils'

const ExternalEmploymentDetails = ({ showLabelAsPlaceholder, label, name, allowNonLatin }) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [isFilled, setIsFilled] = useState(false)
  const [error, setError] = useState('')
  const [isValuePreset, setIsValuePreset] = useState(false)
  const [
    {
      form,
      form: { accId },
      user
    },
    dispatch
  ] = useStore()
  const { employmentDetailsIsShown, employmentDetailsPositionIsShown } = form[accId]
  const showEmploymentDetails = employmentDetailsIsShown || employmentDetailsPositionIsShown
  const userValue = getUserValue(accId, user, name)

  useEffect(() => {
    if (showEmploymentDetails) {
      dispatch({ type: 'addValidationFld', name })
    } else {
      dispatch({ type: 'removeValidationFld', name })
      dispatch({ type: 'removeFieldValue', name })
      setValue('')
      setIsValid(false)
      setIsFilled(false)
    }
  }, [showEmploymentDetails, name])

  const presetValue = (value) => {
    setValue(value)
    const isValid = !!value.length
    setIsValid(isValid)
    !value.trim() ? setIsFilled(false) : setIsFilled(true)
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  useEffect(() => {
    if (userValue && userValue.length && showEmploymentDetails && !isValuePreset) {
      presetValue(userValue)
      setIsValuePreset(true)
    }
  }, [userValue, showEmploymentDetails, name, isValuePreset])

  const onChange = ({ target: { value } }) => {
    setValue(value)
    !value.trim() ? setIsFilled(false) : setIsFilled(true)
  }

  const onBlur = ({ currentTarget: { value, name } }) => {
    const trimmedValue = value.trim()
    const isValid = allowNonLatin ? !!trimmedValue.length : LATIN_WITH_NUMBERS_SYMBOLS.test(trimmedValue)
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
    setIsValid(isValid)
    setError(!isFilled || isValid ? '' : 'generatedField.onlyLatin')
  }

  return showEmploymentDetails ? (
    <InputText
      value={value}
      label={t(label)}
      placeholder=''
      error={t(error)}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      maxLength={MAX_LENGTH}
      valid={isValid}
      showLabelAsPlaceholder={showLabelAsPlaceholder}
    />
  ) : null
}

const getExternalEmploymentDetailsField = field => {
  const { i18n, name, required, order, allowNonLatin } = field
  return (
    <ExternalEmploymentDetails
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      required={required}
      order={order}
      key={name}
      allowNonLatin={allowNonLatin}
    />
  )
}

export { getExternalEmploymentDetailsField, ExternalEmploymentDetails }
